import { render, staticRenderFns } from "./CreateProductView.vue?vue&type=template&id=4c3a2c09"
import script from "./CreateProductView.vue?vue&type=script&lang=js"
export * from "./CreateProductView.vue?vue&type=script&lang=js"
import style0 from "./CreateProductView.vue?vue&type=style&index=0&id=4c3a2c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports